<template>
    <!-- ==========Buttons=========== -->
    <div class="ml-4">

        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Cancel
        </button>

        <button v-on:click="savePivotView"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Save
        </button>

        <button v-on:click="saveDeployPivotView"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Save and Deploy
        </button>

    </div>

    <div class="pivot-container">

        <!-- =====Available fields======= -->
        <div class="bg-gray-50 border-gray-300 mr-4">
            <span class="list-title">Available fields</span>
            <DxList class="available-list" :data-source="list1" :repaint-changes-only="true" key-expr="name"
                display-expr="label.text">

                <DxItemDragging data="list1" :allow-reordering="true" :on-drag-start="onDragStart" :on-add="onAdd"
                    :on-remove="onRemove" group="tasks" />

            </DxList>
        </div>
        <!-- Data Fields -->
        <div class="bg-gray-50 mr-4 field-container">
            <span class="data-title">Data Fields</span>

            <DxList :data-source="list2" :repaint-changes-only="true" key-expr="name" display-expr="caption">

                <DxItemDragging data="list2" :allow-reordering="true" :on-drag-start="onDragStart" :on-add="onAdd"
                    :on-remove="onRemove" group="tasks" />
            </DxList>
        </div>

        <!-- Row Fields -->
        <div class="bg-gray-50 mr-4 field-container">
            <span class="data-title">Row Fields</span>

            <DxList :data-source="list3" :repaint-changes-only="true" key-expr="name" display-expr="caption">

                <DxItemDragging data="list3" :allow-reordering="true" :on-drag-start="onDragStart" :on-add="onAdd"
                    :on-remove="onRemove" group="tasks" />
            </DxList>
        </div>

        <!-- Column Fields -->
        <div class="bg-gray-50 mr-4 field-container">
            <span class="data-title">Column Fields</span>

            <DxList :data-source="list4" :repaint-changes-only="true" key-expr="name" display-expr="caption">

                <DxItemDragging data="list4" :allow-reordering="true" :on-drag-start="onDragStart" :on-add="onAdd"
                    :on-remove="onRemove" group="tasks" />
            </DxList>
        </div>
    </div>
</template>
<script>
import DxList, { DxItemDragging } from 'devextreme-vue/list';
import { getFieldsList, getLayout, setLayout, setDeployLayout } from '../../base.js';

export default {
    props: {
        modulekey: String,
        studio: Boolean,
        route_slug: String,
    },
    components: {
        DxList,
        DxItemDragging,
    },
    data() {
        return {
            fieldList: [],
            allData: [],
            list1: [],
            list2: [],
            list3: [],
            list4: []
        };
    },
    methods: {
        savePivotView() {
            const pivotConfig = [
                // Data Fields
                ...this.list2.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    summaryType: field.summaryType,
                    dataType: field.dataType,
                    area: 'data'
                })),

                // Row Fields
                ...this.list3.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    dataType: field.dataType,
                    summaryType: field.summaryType,
                    width: '120',
                    area: 'row'
                })),

                // Column Fields
                ...this.list4.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    dataType: field.dataType,


                    summaryType: field.summaryType,
                    area: 'column'
                }))
            ];

            const data = JSON.stringify(pivotConfig, null, 2);
            console.log(data);
            setLayout(this.modulekey, "pivotview", this.studio, data, this.route_slug).then(response => {
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });
        },
        saveDeployPivotView() {
            const pivotConfig = [
                // Data Fields
                ...this.list2.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    dataType: field.dataType,
                    summaryType: field.summaryType,
                    area: 'data'
                })),

                // Row Fields
                ...this.list3.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    summaryType: field.summaryType,
                    dataType: field.dataType,
                    width: '120',
                    area: 'row'
                })),

                // Column Fields
                ...this.list4.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    summaryType: field.summaryType,
                    dataType: field.dataType,
                    summaryType: field.summaryType,
                    area: 'column'
                }))
            ];

            const data = JSON.stringify(pivotConfig, null, 2);
            console.log(data);
            setLayout(this.modulekey, "pivotview", this.studio, data, this.route_slug).then(response => {
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });
        },
        saveDeployPivotView() {
            const pivotConfig = [
                // Data Fields
                ...this.list2.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    dataType: field.dataType,
                    summaryType: field.summaryType,
                    area: 'data'
                })),

                // Row Fields
                ...this.list3.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    summaryType: field.summaryType,
                    dataType: field.dataType,
                    width: '120',
                    area: 'row'
                })),

                // Column Fields
                ...this.list4.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    summaryType: field.summaryType,
                    dataType: field.dataType,

                    summaryType: field.summaryType,

                    area: 'column'
                }))
            ];

            const data = JSON.stringify(pivotConfig, null, 2);
            console.log(data);
            setLayout(this.modulekey, "pivotview", this.studio, data, this.route_slug).then(response => {
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });
        },
        saveDeployPivotView() {
            const pivotConfig = [
                // Data Fields
                ...this.list2.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    summaryType: field.summaryType,
                    dataType: field.dataType,
                    summaryType: field.summaryType,
                    area: 'data'
                })),

                // Row Fields
                ...this.list3.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    summaryType: field.summaryType,
                    dataType: field.dataType,
                    summaryType: field.summaryType,
                    width: '120',
                    area: 'row'
                })),

                // Column Fields
                ...this.list4.map(field => ({
                    caption: field.label.text,
                    dataField: field.dataField,
                    summaryType: field.summaryType,
                    dataType: field.dataType,
                    summaryType: field.summaryType,
                    area: 'column'
                }))
            ];

            const data = JSON.stringify(pivotConfig, null, 2);
            this.errors = {};

            setDeployLayout(this.modulekey, "pivotview", this.studio, data, this.route_slug).then(response => {
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });
        },

        onDragStart(e) {
            e.itemData = this[e.fromData][e.fromIndex];
        },
        onAdd(e) {
            const data = [...this[e.toData]];
            data.splice(e.toIndex, 0, e.itemData);
            this[e.toData] = data;
        },
        onRemove(e) {
            const data = [...this[e.fromData]];
            data.splice(e.fromIndex, 1);
            this[e.fromData] = data;
        }
    },
    created: function () {
        this.errors = {};
        getFieldsList(this.modulekey, this.studio, false, this.route_slug).then(response => {
            this.allData = Object.values(response.data);
            this.fieldList = Object.values(response.data);
        }).catch(error => {
            if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
            }
        });

        getLayout(this.modulekey, "pivotview", this.studio, this.route_slug).then(response => {
            const data = response.data;
            this.list1 = this.allData.filter(item => !data.find(field => item.dataField === field.dataField));

            this.list2 = data.filter(item => item.area === "data");
            this.list3 = data.filter(item => item.area === "row");
            this.list4 = data.filter(item => item.area === "column");
        }).catch(error => {
            if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
            }
        });
    }
};
</script>

<style>
.pivot-container {
    display: flex;
    width: 75%;
    margin: 20px;
    /* flex-wrap: wrap; */
}

.pivot-container>* {
    /* width: calc(33.33% - 20px);
    margin-bottom: 20px; */
    height: 400px;
    width: 75%;
    padding: 10px;
}

hr {
    border-top: 1px solid #ccc;
    margin: 10px 0;
}

.pivot-container .dx-list {
    max-height: 400px;
    overflow-y: auto;
}

.pivot-container .available-list {
    max-height: 400px !important;
}

.field-container {
    overflow-y: auto;
}

.field-container::-webkit-scrollbar {
    width: 6px;
    /* Reduce the width of the scrollbar */
}

.field-container::-webkit-scrollbar-thumb {
    background-color: #888;
    /* Color of the scrollbar thumb */
    border-radius: 3px;
    /* Rounded corners for the thumb */
}

.field-container::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    /* Color of the scrollbar track */
}

/* Hover effect to increase scrollbar width */
.field-container:hover::-webkit-scrollbar {
    width: 12px;
    /* Increase the width of the scrollbar on hover */
}

.field-container:hover::-webkit-scrollbar-thumb {
    background-color: #a09f9f;
    /* Darker color on hover */
    transition: 1.65s;
}

/*
.widget-container {
    display: flex;
    width: 75%;
    margin: 20px;
}

.widget-container>* {
    height: 400px;
    width: 75%;
    padding: 10px;
}

.dx-scrollview-content {
    min-height: 380px;
}

.list-title {
    font-size: 16px;
    padding: 10px;
    padding-left: 30px;
    font-weight: bold;
    cursor: pointer;
}*/
</style>